import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateShowFolioDrawer,
  updateShowTakePaymentDrawer,
  updateDisplayInvoiceDrawer,
  updateDisplayPaymentPrintDrawer,
  updateShowSendPaymentLinkDrawer,
  updateShowRefundPaymentDrawer,
} from "../../../reducer/bookingReducer";
import { useState, useRef } from "react";
import RefundIcon from "../../../assets/images/svgs/Refund.svg";
import { Button, Drawer } from "antd";
import { FOLIO_FORMAT } from "../../../utils/helper";
import { ReactComponent as PrinterIcon } from "../../../assets/icons/printerIcon.svg";
import { CircularProgress } from "@mui/material";

import InvoiceStatement from "../../common/Template/InvoiceStatement";
import NewInvoiceStructure from "../../common/Template/NewInvoiceStructure";

import { BsDownload } from "react-icons/bs";
import { IoIosArrowRoundBack } from "react-icons/io";
import { bookingDetailsDrawerWidth } from "../../../utils/bookingDetailsHelper";
import { getCurrentCurrency } from "../../../utils/customCurrencyHelper";
import { BiEdit } from "react-icons/bi";
import { updateEditPaymentDrawer } from "../../../reducer/paymentReducer";

import useFolio from "../../../hooks/bookingCustomHook/useFolio";
import usePrint from "../../../hooks/usePrint";
import usePdf from "../../../hooks/usePdf";

import { Dropdown } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";

const ViewFolioDrawer = () => {
  const dispatch = useDispatch();
  const componentRef = useRef(null);
  const { hotelDetails, isAllHotelsSelected } = useSelector(
    (store) => store.login,
  );

  const {
    responseDetails,
    showFolio,
    paymentDetails: updatedPaymentDetails,
    customerDetails,
    invoiceDetails: updatedInvoiceDetails,
    isBookingAlterationAllowed,
  } = useSelector((store) => store.booking);
  const { bookingDetails } = responseDetails;
  const { response } = useSelector((store) => store.rooms);
  const { response: posData } = useSelector((store) => store.posSetting);

  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [selectedCustomerIndex, setSelectedCustomerIndex] = useState(0);
  const [filter, setFilter] = useState("all");
  const [combinedInvoices, setCombinedInvoices] = useState([]);

  const [posNames, setPosNames] = useState();
  const [roomDetails, setRoomDetails] = useState({});

  const { editBookingAllowed } = useSelector((store) => store.usersRestriction);

  const handleFolioClose = () => {
    dispatch(updateShowFolioDrawer());
    setFilter("all");
  };

  const { symbol, position } = getCurrentCurrency(hotelDetails?.currency);

  const { invoiceAmount, paymentReceived, dueAmount, roomInvoice } = useFolio(
    setCombinedInvoices,
    setRoomDetails,
    posNames,
    setPosNames,
    filteredInvoices,
    setFilteredInvoices,
    posData,
    filter,
  );

  const { loading: isInvoiceLoading, printFile: printInvoiceFile } = usePrint(
    componentRef,
    "Invoice",
  );
  const { loading: isStatementLoading, printFile: printStatementFile } =
    usePrint(componentRef, "Statement");

  const {
    loading: isDownloadInvoiceLoading,
    targetRef,
    generatePDF: generateInvoicePDF,
  } = usePdf("Invoice");
  const {
    loading: isDownloadStatementLoading,
    targetRef: statementRef,
    generatePDF: generateStatementPDF,
  } = usePdf("Statement");

  const handleSelectCustomer = (e) => {
    setSelectedCustomerIndex(e.key);
  };

  const customersDropDownList = [];
  customerDetails?.forEach((customer, index) => {
    customersDropDownList.push({
      key: index,
      label: customer?.name || "Guest",
      onClick: handleSelectCustomer,
    });
  });

  return (
    <>
      <Drawer
        headerStyle={{ padding: 0 }}
        bodyStyle={{
          padding: "0",
          paddingBottom: "0",
        }}
        title={
          <DrawerHeader
            isInvoiceLoading={isInvoiceLoading}
            isStatementLoading={isStatementLoading}
            isDownloadInvoiceLoading={isDownloadInvoiceLoading}
            isDownloadStatementLoading={isDownloadStatementLoading}
            printInvoiceFile={printInvoiceFile}
            printStatementFile={printStatementFile}
            generateInvoicePDF={generateInvoicePDF}
            generateStatementPDF={generateStatementPDF}
            handleFolioClose={handleFolioClose}
          />
        }
        closeIcon={<></>}
        closable={false}
        onClose={handleFolioClose}
        open={showFolio}
        width={bookingDetailsDrawerWidth}
      >
        <div className="w-[100%] h-[100%]  relative">
          <Header
            bookingDetails={bookingDetails}
            position={position}
            symbol={symbol}
            invoiceAmount={invoiceAmount}
            paymentReceived={paymentReceived}
            dueAmount={dueAmount}
            customersDropDownList={customersDropDownList}
            selectedCustomerIndex={selectedCustomerIndex}
          />

          <Tab filter={filter} setFilter={setFilter} />

          <FolioBody
            combinedInvoices={combinedInvoices}
            roomDetails={roomDetails}
            posNames={posNames}
            updatedPaymentDetails={updatedPaymentDetails}
            dispatch={dispatch}
            bookingDetails={bookingDetails}
            customerDetails={customerDetails}
            response={response}
            updatedInvoiceDetails={updatedInvoiceDetails}
            position={position}
            symbol={symbol}
            isEditAlterationAllowed={isBookingAlterationAllowed}
          />
          {Boolean(isBookingAlterationAllowed) && (
            <Footer
              paymentAllowed={editBookingAllowed && !isAllHotelsSelected}
              dispatch={dispatch}
            />
          )}
        </div>
      </Drawer>

      {isStatementLoading && (
        <InvoiceStatement
          hotelDetails={hotelDetails}
          bookingDetails={bookingDetails}
          invoiceDetails={updatedInvoiceDetails}
          paymentDetails={updatedPaymentDetails}
          customerDetails={customerDetails?.[selectedCustomerIndex]}
          response={response}
          roomDetails={roomDetails}
          roomInvoice={roomInvoice}
          invoiceId={roomInvoice?.invoiceId}
          val={componentRef}
          print={true}
          download={false}
          posData={posData}
        />
      )}
      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        <InvoiceStatement
          hotelDetails={hotelDetails}
          bookingDetails={bookingDetails}
          invoiceDetails={updatedInvoiceDetails}
          paymentDetails={updatedPaymentDetails}
          customerDetails={customerDetails?.[selectedCustomerIndex]}
          response={response}
          roomDetails={roomDetails}
          roomInvoice={roomInvoice}
          invoiceId={roomInvoice?.invoiceId}
          targetRef={statementRef}
          print={false}
          download={true}
          posData={posData}
        />
      </div>
      {isInvoiceLoading && (
        <NewInvoiceStructure
          targetRef={targetRef}
          hotelDetails={hotelDetails}
          bookingDetails={bookingDetails}
          invoiceDetails={filteredInvoices?.filter(
            (obj) => !Boolean("amount" in obj),
          )}
          paymentDetails={updatedPaymentDetails}
          invoiceId={roomInvoice?.invoiceId}
          roomInvoice={roomInvoice}
          customerDetails={customerDetails?.[selectedCustomerIndex]}
          roomDetails={roomDetails}
          posNames={posNames}
          val={componentRef}
          print={true}
          download={false}
          posData={posData}
          isSingleInvoice={filter === "roomBill" ? true : false}
          isSummarized={
            hotelDetails?.posComponentsFormatInRoomBill === "summarized"
          }
          isAllInvoice={filter === "all"}
        />
      )}

      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        <NewInvoiceStructure
          targetRef={targetRef}
          hotelDetails={hotelDetails}
          bookingDetails={bookingDetails}
          invoiceDetails={filteredInvoices?.filter(
            (obj) => !Boolean("amount" in obj),
          )}
          paymentDetails={updatedPaymentDetails}
          invoiceId={roomInvoice?.invoiceId}
          customerDetails={customerDetails?.[selectedCustomerIndex]}
          roomDetails={roomDetails}
          roomInvoice={roomInvoice}
          allSelected={false}
          print={false}
          download={true}
          isSingleInvoice={filter === "roomBill" ? true : false}
          posData={posData}
          isSummarized={
            hotelDetails?.posComponentsFormatInRoomBill === "summarized"
          }
          isAllInvoice={filter === "all"}
        />
      </div>
    </>
  );
};

const DrawerHeader = ({
  isInvoiceLoading,
  isStatementLoading,
  isDownloadInvoiceLoading,
  isDownloadStatementLoading,
  printInvoiceFile,
  printStatementFile,
  generateInvoicePDF,
  generateStatementPDF,
  handleFolioClose,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="bg-surface-muted px-5 py-3 border-b-[1px] border-surface-muted flex justify-between items-center gap-3 ">
      <div className="flex items-center gap-3">
        <IoIosArrowRoundBack
          className="text-[30px] text-fg"
          onClick={handleFolioClose}
        />
        <span className=" font-[500] text-[18px] leading-[27px] text-fg">
          Bills
        </span>
      </div>

      <div className="flex gap-5 items-center">
        <div className="flex font-body font-500 text-[13px] leading-[20px] bg-primary-light gap-6 px-3 p-2 items-center rounded-[5px]">
          Statement{" "}
          <span className="flex gap-3 cursor-pointer ">
            {isStatementLoading ? (
              <CircularProgress size={16} />
            ) : (
              <PrinterIcon className="text-primary" onClick={printStatementFile} />
            )}
            {isDownloadStatementLoading ? (
              <CircularProgress size={16} />
            ) : (
              <BsDownload
                className="text-primary text-[20px]"
                onClick={generateStatementPDF}
              />
            )}{" "}
          </span>
        </div>

        <div className="flex font-body font-500 text-[13px] leading-[20px] bg-primary-light gap-6 px-3 p-2 items-center rounded-[5px]">
          Invoice{" "}
          <span className="cursor-pointer flex gap-3">
            {isInvoiceLoading ? (
              <CircularProgress size={16} />
            ) : (
              <PrinterIcon className="text-primary" onClick={printInvoiceFile} />
            )}

            {isDownloadInvoiceLoading ? (
              <CircularProgress size={16} />
            ) : (
              <BsDownload
                className="text-primary text-[20px]"
                onClick={generateInvoicePDF}
              />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

const Header = ({
  bookingDetails,
  position,
  symbol,
  invoiceAmount,
  paymentReceived,
  dueAmount,
  customersDropDownList,
  selectedCustomerIndex,
}) => {
  return (
    <header className="flex flex-col gap-4  mx-5 mb-2 w-[95%]">
      <div className="bottomSection flex justify-between items-center">
        <div className="bottomLeftSection flex flex-col gap-0">
          <div className="my-3">
            <Dropdown
              menu={{ items: customersDropDownList }}
              trigger={["click"]}
            >
              <Button>
                {customersDropDownList?.[selectedCustomerIndex]?.label}{" "}
                <DownOutlined />
              </Button>
            </Dropdown>
          </div>

          <div className=" font-[400] text-[14px] leading-[21px] text-neutral-400">
            Total Amount
          </div>
          <div className=" font-[500] text-[24px] leading-[36px] text-fg">
            {`${position === "before" ? symbol : ""} ${
              Boolean(invoiceAmount) ? FOLIO_FORMAT(invoiceAmount) : "00"
            } ${position === "after" ? ` ${symbol}` : ""}`}{" "}
          </div>
        </div>
        <div className="bottomRightSection flex flex-col gap-1">
          <div className=" font-[400] text-[14px] leading-[21px] text-neutral-400">
            Paid:{" "}
            <span className=" font-[500] text-[14px] leading-[21px] text-fg">
              {`${position === "before" ? symbol : ""} ${
                Boolean(paymentReceived) ? FOLIO_FORMAT(paymentReceived) : "00"
              } ${position === "after" ? ` ${symbol}` : ""}`}
            </span>
          </div>
          <div className=" font-[400] text-[14px] leading-[21px] text-neutral-400">
            Total Due:{" "}
            <span className=" font-[500] text-[14px] leading-[21px] text-danger">
              {`${position === "before" ? symbol : ""} ${
                Boolean(dueAmount) ? FOLIO_FORMAT(dueAmount) : "00"
              } ${position === "after" ? ` ${symbol}` : ""}`}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

const Tab = ({ filter, setFilter }) => {
  return (
    <div className="w-[100%] flex justify-between">
      <div
        className={`${
          filter === "all"
            ? "border-b-primary border-b-[2px] text-primary font-[500]"
            : "border-b-surface border-b-[2px] text-fg-muted font-[400]"
        } w-[20%]   leading-[18px] text-[14px] ] p-2 flex justify-center items-center cursor-pointer`}
        onClick={() => setFilter("all")}
      >
        All
      </div>
      <div
        className={`${
          filter === "roomBill"
            ? "border-b-primary border-b-[2px] text-primary font-[500]"
            : "border-b-surface border-b-[2px] text-fg-muted font-[400]"
        } w-[20%]   leading-[18px] text-[14px] ] p-2 flex justify-center items-center cursor-pointer`}
        onClick={() => setFilter("roomBill")}
      >
        Rooms
      </div>
      <div
        className={`${
          filter === "pos"
            ? "border-b-primary border-b-[2px] text-primary font-[500]"
            : "border-b-surface border-b-[2px] text-fg-muted font-[400]"
        } w-[20%]   leading-[18px] text-[14px] ] p-2 flex justify-center items-center cursor-pointer`}
        onClick={() => setFilter("pos")}
      >
        POS
      </div>
    </div>
  );
};

const FolioBody = ({
  combinedInvoices,
  updatedPaymentDetails,
  dispatch,
  bookingDetails,
  customerDetails,
  response,
  roomDetails,
  posNames,
  updatedInvoiceDetails,
  position,
  symbol,
  isEditAlterationAllowed,
}) => {
  return (
    <main>
      <div
        className="h-[50px] w-full pl-4 pr-[20px] flex justify-between items-center
   border-b border-b-overlay-hover bg-surface-muted  font-[500] text-[12px] leading-[15px] text-fg-muted"
      >
        <div className="w-[16%] px-3  ml-[4px]">Date</div>
        <div className="w-[20%] px-3 ml-[4px] text-left">Invoice No</div>
        <p className="w-[20%] px-3 ">Description</p>
        <p className="w-[16%] px-3 ">Debit</p>
        <p className="w-[14%] px-3 ">Credit</p>
        <p className="w-[14%] px-3">Due </p>
        <p className="w-[5%] px-3">Action</p>
      </div>

      <div className="absolute w-[100%]  h-[60vh]  overflow-auto">
        {combinedInvoices &&
          combinedInvoices?.map((invoice, index) => {
            let paymentObj = {};
            if (invoice?.type === "payment") {
              paymentObj =
                updatedPaymentDetails?.find(
                  ({ paymentId }) => paymentId === invoice?.id,
                ) || {};
            }

            return (
              <div
                onClick={() => {
                  invoice?.type === "payment"
                    ? dispatch(
                        updateDisplayPaymentPrintDrawer({
                          display: true,
                          paymentObject: invoice,
                          invoiceDetails: invoice,
                          bookingDetails: bookingDetails,
                          customerDetails: customerDetails,
                          paymentDetails: updatedPaymentDetails,
                          response: response,
                          roomDetails: roomDetails,
                          posNames: posNames,
                        }),
                      )
                    : dispatch(
                        updateDisplayInvoiceDrawer({
                          display: true,
                          bookingDetails: bookingDetails,
                          invoiceDetails: updatedInvoiceDetails,
                          updatedInvoiceDetails: updatedInvoiceDetails,
                          paymentDetails: updatedPaymentDetails,
                          invoiceId: invoice.invoiceRefrenceId,
                          customerDetails: customerDetails,
                          response: response,
                          roomDetails: roomDetails,
                          posNames: posNames,
                        }),
                      );
                }}
                className=" shadow-sm cursor-pointer  w-[100%] flex justify-between items-center 
                   border-b border-b-brand-border-muted  font-[500]  text-[12px]"
                key={invoice?.id}
              >
                <div className="w-[16%] p-3 flex flex-col">
                  <p className="font-[500]  text-fg">{invoice?.date}</p>
                  <p className=" font-[400]  text-fg-placeholder">{invoice?.time}</p>
                </div>

                <p className="w-[20%] p-3  text-accent  ml-[4px] text-left ">
                  {invoice?.id}
                </p>

                <div className="w-[20%] p-3 mb-[2px]">
                  <p className=" text-fg">{invoice?.description}</p>
                  <p className="font-[400]  text-fg-placeholder">
                    {invoice?.detailedDescription}
                  </p>
                </div>

                <p className="w-[16%] p-3 font-[400]  text-fg flex justify-start items-center gap-2">
                  {invoice && invoice?.debit && invoice?.debit === "NA"
                    ? "NA"
                    : `${position === "before" ? symbol : ""} ${
                        invoice.debit
                      } ${position === "after" ? ` ${symbol}` : ""}`}
                </p>

                <p className="w-[14%] p-3  font-[400]  text-fg flex items-center gap-2">
                  {invoice && invoice?.credit && invoice?.credit === "NA"
                    ? "NA"
                    : `${position === "before" ? symbol : ""} ${
                        invoice.credit
                      } ${position === "after" ? ` ${symbol}` : ""}`}
                </p>

                <p className="w-[14%] p-3  font-[400]  text-fg ">
                  {invoice && invoice.due && invoice?.due === "NA"
                    ? "NA"
                    : `${position === "before" ? symbol : ""} ${invoice.due} ${
                        position === "after" ? ` ${symbol}` : ""
                      }`}
                </p>

                {invoice?.type === "payment" && isEditAlterationAllowed ? (
                  <span
                    className="p-3 "
                    onClick={(e) => {
                      dispatch(
                        updateEditPaymentDrawer({
                          display: true,
                          paymentObj: paymentObj,
                        }),
                      );
                      e.stopPropagation();
                    }}
                  >
                    <BiEdit className="text-fg-placeholder cursor-pointer  h-[14px] w-[14px]" />
                  </span>
                ) : (
                  <span className="p-3 ">N.A</span>
                )}
              </div>
            );
          })}
      </div>
    </main>
  );
};

const Footer = ({ dispatch }) => {
  return (
    <div
      className="w-[100%] absolute bottom-0 right-0 border-t-[1px] 
      border-brand-border-muted p-3 pr-5 flex justify-end gap-3 z-[40] shadow-xl shadow-mobile-footer"
    >
      <Button
        className="text-[1.125rem] py-4 uppercase flex font-[600] border-primary text-primary"
        onClick={() => dispatch(updateShowSendPaymentLinkDrawer())}
      >
        Send Payment Link
      </Button>

      <button
        className="text-[0.875rem] h-[36px] whitespace-nowrap flex gap-2 justify-center items-center bg-primary-light 
            font-[500] text-primary px-2 py-2 rounded-md"
        onClick={() => dispatch(updateShowRefundPaymentDrawer())}
      >
        <img src={RefundIcon} alt="" />
        Refund
      </button>

      <Button
        type="primary"
        className="text-[1.125rem] py-4 uppercase flex font-[600]"
        onClick={() => dispatch(updateShowTakePaymentDrawer())}
      >
        Take Payment
      </Button>
    </div>
  );
};

export default ViewFolioDrawer;
